export default [{
    name: 'Credit',
    path: `credit`,
    component: () => import('./View.vue'),
}];
